<template>
  <w-popup :state="authorityState" @handleClose="handleClose">
    <div class="authority-container" slot="content">
      <div class="authority-header flex-between">
        <div class="auth-info flex-start">
          <img :src="currentOperationUser.avatar" alt="">
          <div class="info flex-column">
            <span class="name">{{ currentOperationUser.name }}</span>
            <!-- <span class="post">超级简历 · UI设计师</span> -->
            <span class="auth-visit-time">上次查看：{{currentOperationUser.updated_at | timeFilter(`MM-DD HH:mm`)}}</span>
          </div>
        </div>
        <!-- <span class="auth-visit-time">{{currentOperationUser.updated_at | timeFilter(`MM-DD HH:mm`)}}</span> -->
      </div>
      <div class="authority-content">
        <div class="select-authority-item flex-start" @click="changeAuthVisibility(20)">
          <i class="iconfont iconxuanzhong3" :class="{'is-active': currentOperationUser.visibility === 20}"></i>
          <div class="flex-column">
            <span class="title">完整可见</span>
            <span class="description">可以查看你的完整简历</span>
          </div>
        </div>
        <div class="select-authority-item flex-start" @click="changeAuthVisibility(10)">
          <i class="iconfont iconxuanzhong3" :class="{'is-active': currentOperationUser.visibility === 10}"></i>
          <div class="flex-column">
            <span class="title">保护隐私</span>
            <span class="description">可查看简历，但会隐藏你的姓名及联系方式</span>
          </div>
        </div>
        <div class="select-authority-item flex-start" @click="changeAuthVisibility(0)">
          <i class="iconfont iconxuanzhong3" :class="{'is-active': currentOperationUser.visibility === 0}"></i>
          <div class="flex-column">
            <span class="title">不可见</span>
            <span class="description">他（她）将无法查看你的简历</span>
          </div>
        </div>
      </div>
      <div class="authority-bottom flex-center" @click="handleClose">取消</div>
    </div>
  </w-popup>
</template>

<script>
  import WPopup from '../../../../components/global/w-popup'
  export default {
    props: {
      authorityState: {
        type: Boolean,
        default: false
      },
      currentOperationUser: {
        type: Object,
        default: () => {}
      }
    },
    data(){
      return {
      }
    },
    mounted() {},
    components: {
      WPopup
    },
    watch: {},
    computed: {},
    methods: {
      handleClose() {
        this.$emit('handleClose')
      },
      changeAuthVisibility(visibility) {
        this.$emit('changeAuthVisibility', visibility)
      }
    }
  }
</script>
<style scoped lang="scss">
  @import '@/assets/scss/global/variable';
  @import '@/assets/scss/global/mixin';
  .authority-container {
    width: 100%;
  }
  .authority-header {
    padding: 20px 24px;
    align-items: flex-start;
    border-bottom: 1px solid #F9F9F9;
    .auth-info {
      img {
        width: 44px;
        height: 44px;
        border-radius: 50%;
        border: 1px solid #f4f4f4;
        margin-right: 12px;
      }
      .info {
        .name {
          font-size: $font-size-medium-x;
          color: $color-title;
          line-height: 22px;
          font-weight: 500;
          margin-bottom: 3px;
          @include ellipsis(calc(100vw - 102px))
        }
        .post {
          color: #9c9c9c;
          font-size: 13px;
          line-height: 18px;
        }
      }
    }
    .auth-visit-time {
      color: #bcbcbc;
      font-size: 12px;
      line-height: 17px;
    }
  }
  .authority-content {
    padding: 0 24px;
    .select-authority-item {
      padding: 16px 0 16px 12px;
      border-bottom: 1px solid #f9f9f9;
      i {
        margin-right: 25px;
        font-size: 18px;
        color: $color-light;
      }
      .is-active {
        color: $color-theme;
      }
      .title {
        color: $color-title;
        font-size: $font-size-medium-x;
        line-height: 22px;
        margin-bottom: 2px;
      }
      .description {
        color: #9c9c9c;
        font-size: $font-size-small;
        line-height: 17px;
      }
      &:last-child {
        border-bottom: none;
      }
    }
  }
  .authority-bottom {
    width: 100%;
    padding-top: 12px;
    @include ipx-content-bottom(12px);
    color: $color-dark-gray;
    font-size: $font-size-medium-x;
    line-height: 22px;
    border-top: 6px solid #f9f9f9;
  }
</style>